<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <a class="nav-link mr20"><icon name="flag"></icon></a>
        </template>
        <b-dropdown-item v-for="item in data.root" :key="item.langId" v-on:click="fetchLanguage(item.langId)"><a>{{$t(item.langName)}}</a></b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Api from '@/api/admin/TransLang'

export default
{
  name: 'header-dropdown-accnt',
  created: function()
  {
    var me = this;
    me.getData();
  },
  data: function()
  {
    return {
      data: {},
      pagination:
      {
        currentPage: 1,
        limit: 20
      }
    }
  },
  methods:
  {
    ...mapActions([
      'fetchLanguage'
    ]),
    getData: function()
    {
      var me = this;
      Api.selectRow(me.pagination, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.data = data;
      });
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
